import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { ThermometerModuleDataApiModel, WVCustom, WVMain } from '../wallboard-view.model';
import { ThermometerSettingsTransferObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-custom-thermometer',
    templateUrl: './wallboard-view-custom-thermometer.component.html',
    styleUrls: ['./wallboard-view-custom-thermometer.component.scss']
})
export class WallboardViewCustomThermometerComponent implements OnInit, OnDestroy {
    @Input() index;
    @Input() firstSlide;

    public wvf: WVMain;
    public wvcf: WVCustom;
    public thermoState: ThermometerSettingsTransferObj;
    public thermoData: ThermometerModuleDataApiModel;
    public thermoMetricName: string = "";

    public slideError: boolean = false;
    public directionUp: number = 1;

    private updateTimerRef: NodeJS.Timeout = null;
    private isDestroyed: boolean = false;
    private _moduleKey: string = "";
    private _hasBackdrop: boolean = false;

    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }

    get moduleKey(): string {
        return this._moduleKey;
    }

    constructor(
        private service: WallboardViewService
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvcf = this.service.WVCustom;

        this._moduleKey = this.wvcf?.Slide.WallboardModuleDetails[this.index].WallboardModuleKey ?? "";
        this._hasBackdrop = this.wvcf?.Slide.HasBackdrop ?? false;


        let moduleState = this.loadModuleState().then(response => {
            if (this.isDestroyed)
                return;

            this.thermoState = response.thermometerObj;
        });

        let thermometerModuleData = this.getThermometerModuleData().then(response => {
            if (this.isDestroyed)
                return;

            this.thermoData = response;
        });

        this.getMetricName().then(response => {
            if (this.isDestroyed)
                return;

            this.thermoMetricName = response;
        });

        Promise.all([moduleState, thermometerModuleData]).then(responses => {
            if (this.isDestroyed)
                return;

            if (!this.firstSlide) {
                let dup = false;

                for (let i = 0; i < this.wvcf.ReadyModules.length; i++) {
                    if (this.moduleKey == this.wvcf.ReadyModules[i]) {
                        dup = true;
                        break;
                    }
                }

                if (!dup)
                    this.wvcf.ReadyModules.push(this.moduleKey);
            }

            this.runUpdatedSlide();

            if (!this.updateTimerRef) {
                const refreshInterval = this.thermoData.Has_Current_Metric
                    ? WallboardViewService.REALTIME_DATA_REFRESH_INTERVAL
                    : WallboardViewService.HISTORICAL_DATA_REFRESH_INTERVAL;
    
                this.updateTimerRef = setInterval(() => this.updateSlideData(), refreshInterval);
            }
        });
    }

    ngOnDestroy(): void {
        // End data updates
        if (this.updateTimerRef != null)
            clearInterval(this.updateTimerRef);

        this.isDestroyed = true;
    }

    public async loadModuleState() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            try {
                return await this.service.loadModuleState(ModuleType.Thermometer, this.wvf.WallboardCreatorID, this.moduleKey);
            }
            catch (error) {
                latestError = error;
            }
        }

        this.slideError = true;

        if (!this.firstSlide) {
            let dup = false;
            for (let i = 0; i < this.wvcf.ReadyModules.length; i++) {
                if (this.moduleKey == this.wvcf.ReadyModules[i]) {
                    dup = true;
                    break;
                }
            }

            if (!dup)
                this.wvcf.ReadyModules.push(this.moduleKey);
        }

        throw latestError;
    }

    public async getThermometerModuleData() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            if (this.isDestroyed)
                return;

            try {
                return await this.service.getThermometerKpiModuleData(this.wvf.Slides[0].WallboardID, this.moduleKey);
            }
            catch (error) {
                latestError = error;
                await new Promise(resolve => setTimeout(resolve, WallboardViewService.ERROR_RETRY_INTERVAL));
            }
        }

        this.slideError = true;

        if (!this.firstSlide) {
            let dup = false;
            for (let i = 0; i < this.wvcf.ReadyModules.length; i++) {
                if (this.moduleKey == this.wvcf.ReadyModules[i]) {
                    dup = true;
                    break;
                }
            }

            if (!dup)
                this.wvcf.ReadyModules.push(this.moduleKey);
        }

        throw latestError;
    }

    public async getMetricName() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            try {
                return await this.service.getMetricName(this.wvf.Slides[0].WallboardID, this.moduleKey);
            }
            catch (error) {
                latestError = error;
            }
        }

        this.slideError = true;

        throw latestError;
    }

    public async updateSlideData() {
        this.getThermometerModuleData().then(response => {
            if (this.isDestroyed)
                return;

            this.thermoData = response;

            this.runUpdatedSlide();
        });

        this.getMetricName().then(response => {
            if (this.isDestroyed)
                return;

            this.thermoMetricName = response;
        });
    }

    public async runUpdatedSlide() {
        let $ele = $(".wvThermoBar" + this.moduleKey);
        let $valueEle = $(".wvThermoDataBox" + this.moduleKey);

        if ((this.wvf.RunSlide || this.firstSlide) && $ele.length > 0) {

            if (this.thermoState.isOverride) { // For isOverride, use the old logic before new objectives were added
                let bound = this.thermoState.LowerBound;
                let value = this.thermoState.Value;

                if (this.thermoData.Metric_Data.Direction == this.directionUp)
                    $ele.css("height", (this.thermoData.Metric_Data.MetricValue - bound) / (value - bound) < 1.1 ? Math.abs((((this.thermoData.Metric_Data.MetricValue - bound) / (value - bound) - 0.1) * 100) - 22) + "%" : "78%");
                else // Has objective and direction 0
                    $ele.css("height", (this.thermoData.Metric_Data.MetricValue - bound) / (value - bound) > 1.1 ? Math.abs((((this.thermoData.Metric_Data.MetricValue - bound) / (value - bound) - 0.1) * 100) - 22) + "%" : "78%");
            }
            else if (this.thermoData.Metric_Data.HasPO) {
                try {
                    // poDetails are from high to low, so get the first poDetails:
                    let highestPoDetail = this.thermoData.Metric_Data.objectiveData.poDetails[0];
                    let percent = this.thermoData.Metric_Data.MetricValue / highestPoDetail.Value;
                    percent = Math.min(percent, 1) * 78; // Max of 78%;
                    $ele.css("height", (isFinite(percent) && percent > 0 ? percent : 0) + "%"); // if percent happens to be undefined, NaN, or Infinity, put 0
                }
                catch (err) {
                    console.error("Exception when calculating the height of the thermometer");
                }
            }
            else
                $ele.css("height", "78%");

            $ele.css({
                width: ($ele.parent().height() / 26.2) + "px", // 26.2 appears to come from the ratio 370/14 (width of the inner thermometer bar, height of the entire background image), but it's more of a magic number modified to get it to fit.  
                "margin-bottom": ($valueEle.parent().height() * 0.0425) + "px",
            });

            $valueEle.css({ "font-size": $valueEle.parent().height() * 0.07 + "px", });

            setTimeout(() => {
                $(".wvThermoDataBox").fadeIn();
            }, 1000);
        }
        else {
            setTimeout(() => {
                this.runUpdatedSlide();
            }, 1000);
        }
    }

    public getNewObjectiveColorStyle() {
        // The colors specified below are from http://clearview.design/design-guidelines/color "New Gauge / Objective Colors"
        if (this.thermoState.isOverride) { // Old way of calculating color
            if (this.thermoData.Metric_Data.Direction == this.directionUp) {
                if (((this.thermoData.Metric_Data.MetricValue - this.thermoState.LowerBound) >= (this.thermoState.Value - this.thermoState.LowerBound)))
                    return { "background-color": "#97c93c" }; // green "Objective Green"
                if (((this.thermoData.Metric_Data.MetricValue - this.thermoState.LowerBound) < (this.thermoState.Alert - this.thermoState.LowerBound)))
                    return { "background-color": "#df1f26" }; // red "Objective Red"
                if (((this.thermoData.Metric_Data.MetricValue - this.thermoState.LowerBound) >= (this.thermoState.Alert - this.thermoState.LowerBound)
                    && (this.thermoData.Metric_Data.MetricValue - this.thermoState.LowerBound) < (this.thermoState.Value - this.thermoState.LowerBound)))
                    return { "background-color": "#f0ce14" }; // yellow "Objective Yellow"
            }
            else {
                if (((this.thermoData.Metric_Data.MetricValue - this.thermoState.LowerBound) <= (this.thermoState.Value - this.thermoState.LowerBound)))
                    return { "background-color": "#97c93c" }; // green "Objective Green"
                if (((this.thermoData.Metric_Data.MetricValue - this.thermoState.LowerBound) > (this.thermoState.Alert - this.thermoState.LowerBound)))
                    return { "background-color": "#df1f26" }; // red "Objective Red"
                if (((this.thermoData.Metric_Data.MetricValue - this.thermoState.LowerBound) <= (this.thermoState.Alert - this.thermoState.LowerBound)
                    && (this.thermoData.Metric_Data.MetricValue - this.thermoState.LowerBound) > (this.thermoState.Value - this.thermoState.LowerBound)))
                    return { "background-color": "#f0ce14" }; // yellow "Objective Yellow"
            }
        }
        else if (this.thermoData.Metric_Data.HasPO && this.thermoData.Metric_Data.objectiveData != null) { // New objectives without override
            // Use poValueColor, since the backend did the logic of calculating it
            return { "background-color": this.thermoData.Metric_Data.objectiveData.poValueColor };
        }

        return { "background-color": "#a8afb9" }; // Default. Gray "Valyrian Steel"
    }
}
